import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { DateTime } from 'luxon'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { diffInMinutes, getDeltaString } from '@utils/dateUtils'
import useStyles from './match-play-status-bar.styles'

const MatchPlayStatusBar = (props) => {
  const {
    updatedAt,
    startDate,
    endDate,
  } = props
  const styles = useStyles()

  let status
  const now = DateTime.local()
  if (now > DateTime.fromISO(endDate)) status = 'complete'
  if ((now >= DateTime.fromISO(startDate)) && (now <= DateTime.fromISO(endDate))) status = 'in progress'
  if (now < DateTime.fromISO(startDate)) status = 'upcoming'

  const updated = new Date(updatedAt * 1)
  const minutesAgo = diffInMinutes(updated)

  return (
    <Box className={styles.root}>
      <Typography variant="overline">{status}</Typography>
      <Divider orientation="vertical" variant="middle" />
      <Typography variant="body2">
        {updatedAt && `Last updated ${getDeltaString(minutesAgo, updated)}`}
      </Typography>
    </Box>
  )
}

MatchPlayStatusBar.propTypes = {
  updatedAt: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default MatchPlayStatusBar
